import { PlcRect } from './PlcContentLoader.component';
import React, { ComponentPropsWithRef, FC } from 'react';

export const TextAreaLoader: FC<ComponentPropsWithRef<'rect'>> = ({ height = 250, rx = 0, ry = 0, ...rest }) => (
  <PlcRect height={height} rx={rx} ry={ry} {...rest} />
);
